// Схлопывание частых событий в одно — для непрерывных контролов (ползунков).
//
// Ползунок «Показывать за последние» отдаёт значение на КАЖДЫЙ пиксель протяжки:
// одно движение мыши от 30 до 180 — это полторы сотни событий, каждое из которых
// уходило и в запрос к серверу, и в запись адресной строки. Ползунок при этом
// должен оставаться отзывчивым, поэтому задерживаем не сам контрол, а то, что
// висит на его значении.

export interface Debounced<T> {
  (value: T): void
  /** Отменить отложенный вызов (размонтирование). */
  cancel(): void
}

/** Вызвать `fn` со ЗНАЧЕНИЕМ последнего вызова, когда поток вызовов затих на `ms`.
 *
 *  Хвост, а не голова: промежуточные значения протяжки бессмысленны, важно то,
 *  на чём палец остановился. */
export function debounce<T>(fn: (value: T) => void, ms: number): Debounced<T> {
  let timer: ReturnType<typeof setTimeout> | null = null

  const run = (value: T) => {
    if (timer !== null) clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
      fn(value)
    }, ms)
  }

  run.cancel = () => {
    if (timer !== null) clearTimeout(timer)
    timer = null
  }

  return run as Debounced<T>
}
